export default {
    methods: {
        getData: function (domain) {
            this.$http
                .get(globalProvider.serviceUrl("exm_c/g/eis/{domain}"), {
                    params: {
                        domain,
                        loading: true
                    }
                })
                .then(data => {
                    if (data.body.code === resultCode.Success) {
                        this.$store.commit(
                            "setCurrentExamInfo",
                            data.body.data
                        );
                        this.$router.push({
                            name: "order.chooseBatch"
                        });

                    } else {
                        this.$router.push({
                            name: "default.notFound"
                        });
                    }
                });
        }
    },
    created: function () {
        if (this.$route.query) {
            let {
                jwt,
                domain
            } = this.$route.query;
            this.$store.commit(
                "setToken",
                "Bearer "+jwt
            );
            this.getData(domain);
        }

    }
}